import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { specMove } from "./glass";

const links = [
  { label: "Manifesto", href: "#manifesto", testid: "header-nav-manifesto" },
  { label: "The System", href: "#services", testid: "header-nav-services" },
  { label: "Who", href: "#who", testid: "header-nav-who" },
];

const DARK_SELECTORS = [
  '[data-testid="chapter-01-alone"]',
  '[data-testid="chapter-02-strategy"]',
  '[data-testid="chapter-05-who-we-work-with"]',
  '[data-testid="cta-section"]',
];

export default function Header({ onContact }) {
  const [onDark, setOnDark] = useState(false);

  useEffect(() => {
    const check = () => {
      const y = 56;
      const dark = DARK_SELECTORS.some((sel) => {
        const el = document.querySelector(sel);
        if (!el) return false;
        const r = el.getBoundingClientRect();
        return r.top <= y && r.bottom >= y;
      });
      setOnDark(dark);
    };
    check();
    window.addEventListener("scroll", check, { passive: true });
    return () => window.removeEventListener("scroll", check);
  }, []);

  return (
    <motion.header
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-4 left-0 right-0 z-50 flex justify-center px-4"
    >
      <div
        onMouseMove={specMove}
        className={`glass-sheen glass-spec flex h-14 w-full max-w-3xl items-center justify-between gap-4 rounded-full pl-4 pr-2 transition-colors duration-500 ${
          onDark ? "glass-dark" : "glass"
        }`}
      >
        <a href="#top" className="relative flex items-center gap-2.5 shrink-0" data-testid="header-logo">
          <img
            src="/vontrail-logo.png"
            alt="VONTRAIL GROWTH logo"
            className="h-7 w-7 rounded-[9px] object-cover"
          />
          <span
            className={`font-semibold tracking-tight text-[15px] hidden sm:block transition-colors duration-500 ${
              onDark ? "text-white" : "text-[#1d1d1f]"
            }`}
          >
            VONTRAIL GROWTH
          </span>
        </a>
        <nav className="relative hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className={`text-xs transition-colors duration-500 ${
                onDark ? "text-white/70 hover:text-white" : "text-[#1d1d1f]/70 hover:text-[#1d1d1f]"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          onClick={onContact}
          onMouseMove={specMove}
          data-testid="header-cta-button"
          className={`glass-spec relative flex h-10 items-center rounded-full px-5 text-xs font-medium transition-transform duration-200 hover:scale-[1.05] active:scale-[0.95] shrink-0 ${
            onDark
              ? "bg-white/90 text-black border border-white/50 shadow-[inset_0_1px_1px_rgba(255,255,255,0.8)]"
              : "glass-strong text-white"
          }`}
        >
          Let's talk
        </button>
      </div>
    </motion.header>
  );
}
